import {forwardRef} from "react";

import {BorderArticle} from "@ui/general/BorderArticle";
import {RootIcon} from "@ui/icons/RootIcon";
import {motion} from "framer-motion";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

const BenefitsHoverCard = forwardRef(({item, itemChild}, ref) => {
  const {isMobile} = useSelector((state) => state.common.settings);

  return (
    <div
      key={item.id}
      ref={ref}
      className={
        item.id === itemChild
          ? `${styles.benefits_root_item} ${styles.benefits_item}`
          : styles.benefits_item
      }
    >
      <BorderArticle>
        <div>
          <i />

          <RootIcon
            width={isMobile ? 32 : 64}
            height={isMobile ? 32 : 64}
            id={item.icon}
          />

          <h3>{item.title}</h3>

          <span>{item.subtitle}</span>
        </div>
      </BorderArticle>
    </div>
  );
});

export const MBenefitsHoverCard = motion(BenefitsHoverCard);
